import { render, staticRenderFns } from "./pending_TP.vue?vue&type=template&id=4090d9c6&scoped=true"
import script from "./pending_TP.vue?vue&type=script&lang=js"
export * from "./pending_TP.vue?vue&type=script&lang=js"
import style0 from "./pending_TP.vue?vue&type=style&index=0&id=4090d9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4090d9c6",
  null
  
)

export default component.exports